import React, { useState, useEffect, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'

import loader from '../../../../assets/img/loader.svg'
import visitpriceHeadImage from '@/assets/img/reservations/icons/visitprice-head.svg'

import Question from '../../../modals/messages/Question'
import EditComment from './modals/EditComment'
import AddComment from './modals/AddComment'
import CommentMenu from './CommentMenu'

function TaskInfoComments({ reservationId, data }) {
    const [comments, setComments] = useState({
        loading: true,
        fromCustomer: [],
        fromEmployees: [],
        activeTab: 'employees',
    })

    const addCommentRef = useRef(null)
    const editCommentRef = useRef(null)
    const questionRef = useRef(null)

    useEffect(() => {
        if (!reservationId) return

        Api.get('reservations/comments?id=' + reservationId)
            .then(res => {
                setComments(prev => ({
                    ...prev,
                    fromCustomer: res.data.filter(c => c.employee_id === null),
                    fromEmployees: res.data.filter(c => c.employee_id !== null),
                    loading: false,
                }))
            })
    }, [reservationId])

    const handleAdded = comment => {
        setComments(prev => ({
            ...prev,
            fromEmployees: [comment, ...prev.fromEmployees],
        }))
    }

    const handleUpdate = e => {
        e.preventDefault()

        Api.post('reservations/comments/edit', new FormData(e.target))
            .then(res => {
                setComments(prev => ({
                    ...prev,
                    fromEmployees: prev.fromEmployees.map(c =>
                        Number(c.id) === Number(res.data.id) ? res.data : c
                    ),
                }))
            })
    }

    const handleDelete = id => questionRef.current.open(id)

    const handleAcceptDelete = id => {
        Api.post('reservations/comments/delete', { id }).then(() => {
            setComments(prev => ({
                ...prev,
                fromEmployees: prev.fromEmployees.filter(c => c.id !== id),
            }))
        })
    }

    const createMarkup = html => ({
        __html: String(html).replaceAll('\n', '<br/>')
    })

    return (
        <div className="pannel">
            <Question
                mainMessage={trans('headings.question3')}
                secondaryMessage={trans('subheadings.confirmDelete')}
                ref={questionRef}
                callback={handleAcceptDelete}
            />
            <AddComment
                ref={addCommentRef}
                callback={handleAdded}
            />
            <EditComment
                ref={editCommentRef}
                handleUpdate={handleUpdate}
            />
            <div className="head">
                <img src={visitpriceHeadImage} alt="visitation" />
                {trans('tabs.comments')}
                <ul className="custom-tabs" style={{ marginLeft: 15 }}>
                    <li
                        className={comments.activeTab === 'employees' ? 'active' : ''}
                        onClick={() => setComments(prev => ({ ...prev, activeTab: 'employees' }))}
                    >
                        {trans('tabs.fromTechnicians')}
                    </li>
                    <li
                        className={comments.activeTab === 'customer' ? 'active' : ''}
                        onClick={() => setComments(prev => ({ ...prev, activeTab: 'customer' }))}
                    >
                        {trans('tabs.fromCustomers')}
                    </li>
                </ul>

            </div>
            {comments.loading
                ? <img src={loader} alt="loading" />
                :
                <>
                    {comments.activeTab === 'customer'
                        ? comments.fromCustomer.length === 0
                            ? <div className="alert warning" style={{ marginBottom: 0 }}>{trans('messages.noCommentsFromClient')}</div>
                            : <ul className="notes-list">
                                {comments.fromCustomer.map(comment =>
                                    <li key={'cc-' + comment.id}>
                                        <div className="title">
                                            <b>{comment.comment}</b>
                                            <p>{comment.author && comment.author.name} {comment.author && comment.author.lastname}</p>
                                        </div>
                                        <div className="time">{comment.created_dmy}</div>
                                        <div className="options" />
                                    </li>
                                )}
                            </ul>
                        : comments.fromEmployees.length === 0
                            ? <div className="alert warning" style={{ marginBottom: 0 }}>{trans('messages.noCommentsFromEmployee')}</div>
                            : <ul className="notes-list">
                                {comments.fromEmployees.map(comment =>
                                    <li key={'ce-' + comment.id}>
                                        <div className="title">
                                            <b dangerouslySetInnerHTML={createMarkup(comment.comment)} />
                                            <p>{comment.author && comment.author.name} {comment.author && comment.author.lastname}
                                                {comment.from_admin ?
                                                    <span className="badge" style={{
                                                        padding: "2px 7px"
                                                    }}>{trans('random.admin')}</span>
                                                    :
                                                    <>
                                                    </>
                                                }
                                            </p>
                                        </div>
                                        <div className="time">{comment.created_dmy}</div>
                                        <div className="options">
                                            {comment.editable &&
                                                <CommentMenu
                                                    onEdit={() => editCommentRef.current.open(comment)}
                                                    onDelete={() => handleDelete(comment.id)}
                                                />
                                            }
                                        </div>
                                    </li>
                                )}
                            </ul>
                    }
                    {comments.activeTab === 'employees' && data.can_modify &&
                        <button
                            type="button"
                            className="button button-add button-small"
                            style={{ marginTop: 15 }}
                            onClick={() => addCommentRef.current.open(reservationId)}
                        >
                            {trans('buttons.addComment')}
                        </button>
                    }
                </>
            }
        </div>
    )
}

export default TaskInfoComments
